import { useNavigate } from 'react-router-dom';
import { setStoredWizardData } from 'Services/Api/_HumanWritten/BookingWizardCacheService';
import { saveBookingWizardDataCacheToken } from 'Views/Components/_HumanWritten/BookingWizard/FerryTripBookingWizard/BookingWizardDataCacheToken';
import { useBookingWizardDataStore } from 'Views/Components/_HumanWritten/BookingWizard/FerryTripBookingWizard/BookingWizardDataStore';

import LoginFlow from './LoginFlow';

export default function LoginStep() {
	const navigate = useNavigate();

	const afterLogin = () => {
		// Go back to the previous tab that the user was on (so that we don't have to figure out
		// what the next tab is as it is dynamic to the booking type and application configurations
		navigate(-1);
	};

	const getWizardDataToken = async () => {
		// Only cache wizard data if we're in the booking wizard context
		// Check the URL to ensure we're actually in the booking wizard
		try {
			const storeState = useBookingWizardDataStore.getState();

			// Check if we have wizard data (meaning we're in the booking wizard)
			if (storeState?.wizardData) {
				const wizardDataToken = await setStoredWizardData(storeState.wizardData);
				saveBookingWizardDataCacheToken(wizardDataToken);
				return wizardDataToken;
			}
		} catch (err) {
			// Not in booking wizard context, or store doesn't exist - that's fine for regular registration
		}

		return null;
	};

	return (
		<div className="login-step">
			<LoginFlow afterLoginSuccess={afterLogin} getWizardDataToken={getWizardDataToken} />
		</div>
	);
}
